// Заглушки для страницы «Календарь». Форма объектов совпадает с тем,
// что удобно отдавать с бэкенда — при подключении API меняется только источник.

export const CALENDAR_GROUPS = [
  {
    id: 'my',
    label: 'Мои календари',
    calendars: [
      { id: 'personal', name: 'Личное', color: '#3b82f6' },
      { id: 'work', name: 'Работа', color: '#22c55e' },
      { id: 'family', name: 'Команда', color: '#ec4899' },
    ],
  },
  {
    id: 'favorites',
    label: 'Избранное',
    calendars: [
      { id: 'releases', name: 'Релизы', color: '#f97316' },
      { id: 'oncall', name: 'Дежурства', color: '#a855f7' },
    ],
  },
  {
    id: 'other',
    label: 'Другое',
    calendars: [
      { id: 'holidays', name: 'Праздники', color: '#64748b' },
    ],
  },
];

// Даты задаём относительно текущего месяца, чтобы заглушка не «протухала».
const monthDay = (day, hour = 10, minute = 0) => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), day, hour, minute).toISOString();
};

export const CALENDAR_EVENTS = [
  {
    id: 'ev-1',
    title: 'Дейли команды',
    calendarId: 'work',
    start: monthDay(11, 10, 0),
    end: monthDay(11, 10, 30),
    location: 'Zoom',
    description: 'Синк по текущим задачам',
  },
  {
    id: 'ev-2',
    title: 'Ревью дизайна',
    calendarId: 'personal',
    start: monthDay(11, 14, 0),
    end: monthDay(11, 15, 0),
    location: 'Переговорка 2',
    description: 'Смотрим макеты новой админки',
  },
  {
    id: 'ev-3',
    title: 'Релиз мобильного приложения',
    calendarId: 'releases',
    start: monthDay(15, 12, 0),
    end: monthDay(15, 13, 0),
    location: '',
    description: 'Выкатка 2.4.0',
  },
  {
    id: 'ev-4',
    title: 'Встреча с клиентом',
    calendarId: 'oncall',
    start: monthDay(18, 16, 0),
    end: monthDay(18, 17, 0),
    location: 'Офис',
    description: '',
  },
  {
    id: 'ev-5',
    title: 'День рождения Ани 🎉',
    calendarId: 'family',
    start: monthDay(20, 18, 0),
    end: monthDay(20, 22, 0),
    location: '',
    description: '',
  },
  {
    id: 'ev-6',
    title: 'Разбор жалоб за неделю',
    calendarId: 'work',
    start: monthDay(22, 11, 0),
    end: monthDay(22, 12, 0),
    location: 'Переговорка 1',
    description: '',
  },
  {
    id: 'ev-7',
    title: 'Дежурство: Максим',
    calendarId: 'oncall',
    start: monthDay(25, 9, 0),
    end: monthDay(25, 21, 0),
    location: '',
    description: '',
  },
];

export const VIEW_VALUES = ['month', 'list'];
